const slpFormCampaignCode = (campaignCode: string) => ({
  'form-campaign_code': campaignCode
});

export default slpFormCampaignCode;
